<div class="public-link__container">
  <div class="public-link__container-show-info"
    [ngClass]="{'public-link__container-show-info--open': publicLinkPoll.showInfo}">
    @if(publicLinkPoll.showInfo){
      <div class="public-link__container-button-show-info">
        <button class="common-button__icon-md-noborder rotate-90"
          (click)="publicLinkPoll.showInfo = false">
          <i class="lf-icon-collapse common-icon__md"></i>
        </button>
      </div>
      <div class="public-link__container-inner-show-info">
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title-principal"
            [afTranslate]="'public-link-poll.public-poll'">_Encuesta público</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link-poll.info-poll'"></div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.what-is-for'">_¿Para qué sirve?</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link-poll.uses'">
          </div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.configuration'">_¿Cómo se configura?</div>
          <div class="public-link__text-info">
            <div class="public-link__text-info"
              [afTranslate]="'public-link-poll.info-recomendation'">
            </div>
          </div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'public-link.link-activate'">_¿Cuándo se activa el enlace?</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link-poll.info-activate'"></div>
        </div>
        <div class="public-link__container-text-info">
          <div class="public-link__container-text-info-title"
            [afTranslate]="'expanded-menu.expiration-period'">_Plazo de expiración</div>
          <div class="public-link__text-info"
            [afTranslate]="'public-link-poll.info-expiration'"></div>
        </div>
      </div>
    }@else {
      <button class="common-button__icon-lg-noborder"
        (click)="publicLinkPoll.showInfo = true">
        <i class="lf-icon-info-full common-icon__md"></i>
      </button>
    }
  </div>
  <div class="public-link__main-container"
    [ngClass]="{'public-link__main-container--open-info': publicLinkPoll.showInfo}">
    @if (publicLinkPoll.published){
      <div class="public-link__info-header-container-published">
        <button-with-text-menu
          [item]="publicLinkPoll.shareUrlItem"
          [buttonClass]="'common-button__text-noborder'"
          [textButton]="'public-link.share-url' | afTranslate"
          [multiline]="1"
          [disabled]="!concept.url"
          (launchActionEmitter)="launchActionLink($event.option)">
        </button-with-text-menu>
        <button class="common-button__text-noborder"
          (click)="unpublishPoll()">
          <span class="common-button__text-title"
            [afTranslate]="'expanded-menu.unpublish'">_Despublicar</span>
        </button>
      </div>
    }@else {
      <div class="public-link__info-header-container"
        [afTranslate]="'public-link-poll.title-steps'">
        _Vas a compartir públicamente la encuesta. Por favor, configura el espacio web de publicación con los siguientes elementos corporativos.
      </div>
    }
    @if (publicLinkPoll.steps.length !== 1) {
      <wizard-steps [steps]="publicLinkPoll.steps" [state]="publicLinkPoll.stepState"></wizard-steps>
    }
    @switch (publicLinkPoll.stepState) {
      @case (1) {
        <div class="configure-customization__container-step">
          @if(publicLinkPoll.infoCustomizationPreview === 'global' || publicLinkPoll.infoCustomizationPreview === 'customized' ){
            <div class="common-status-message__g-container-info">
              <i class="lf-icon-info-full common-status-message__icon-md"></i>
              <div class="common-status-message__g-content">
                  <div class="common-status-message__g-icon-text-content">
                    <div class="common-status-message__g-title-subtitle">
                      <span class="common-status-message__g-subtitle"
                        [afTranslate]="publicLinkPoll.infoCustomizationPreview === 'customized'?'corporative-information-modal.identity-specific-info':'corporative-information-modal.identity-global'"></span>
                    </div>
                  </div>
                  @if (publicLinkPoll.infoCustomizationPreview === 'customized') {
                    <div class="common-status-message__g-buttons-container">
                      <button class="common-button__link"
                        (click)="glConfig()">
                        <span class="common-button__link-text"
                          [afTranslate]="'corporative-information-modal.restore-global-personalization'">_Restaurar personalización global</span>
                      </button>
                    </div>
                  }
              </div>
            </div>
          }
          <div class="configure-customization__form-container">
            <div class="common-container__mandatory-obligatory-message-form">
              <span class="common-tag__mandatory-text-asterisk">*</span>
              <span class="common-tag__mandatory-label-text-obligatory-message"
                [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
            </div>
            <div class="configure-customization__inputs-container">
              <div class="configure-customization__inner-inputs-container">
                <field-type-logo #clientLogoComp class="field-type-logo__outer-container"
                  [field]="publicLinkPoll.clientLogo"
                  [type]="'new'"
                  [preSelectItem]="publicLinkPoll.company.allLogos"
                  [logoInfo]="publicLinkPoll.company"
                  (itemSelected)="itemSelectedOn($event, 'logo')">
                </field-type-logo>
                <field-type-logo
                  [field]="publicLinkPoll.clientFavicon"
                  [type]="'favicon'"
                  [logoInfo]="publicLinkPoll.company"
                  [preSelectItem]="publicLinkPoll.company.faviconImg"
                  (itemSelected)="itemSelectedOn($event, 'favicon')">
                </field-type-logo>
              </div>
              <div class="configure-customization__inner-inputs-container">
                <field-type-color
                  [field]="publicLinkPoll.color"
                  [preSelectItem]="publicLinkPoll.company.corporativeInformation.color"
                  (itemSelectedEmit)="itemSelectedOn($event, 'color')">
                </field-type-color>
                <field-type-color
                  [field]="publicLinkPoll.textColor"
                  [preSelectItem]="publicLinkPoll.company.corporativeInformation.textColor"
                  (itemSelectedEmit)="itemSelectedOn($event, 'textColor')">
                </field-type-color>
                <field-type-list-extended [field]="publicLinkPoll.footerDesignType"
                  [preSelectItem]="publicLinkPoll.company.corporativeInformation.footerDesignType"
                  [listValues]="publicLinkPoll.footerDesignTypeList"
                  (itemSelected)="itemSelectedOn($event, 'footerDesignType')">
                </field-type-list-extended>
              </div>
            </div>
          </div>
        </div>
      }
      @case (2) {
        <div class="configure-customization__form-container">
          <div class="protection-data-modal__translation-container">
            <div class="common-translations__container">
              <ul class="common-tab__tertiary-list-block">
                @for (selectedLanguage of publicLinkPoll.linkPollLanguagesSelected; track selectedLanguage.listValueId) {
                  <li>
                    <button [ngClass]="{'common-tab__tertiary--selected': selectedLanguage.active && !selectedLanguage.error}"
                      (click)="changeActiveLanguagesSelected(selectedLanguage)"
                      class="common-tab__tertiary">
                      <p class="common-tab__tertiary-button-text"
                        [ngClass]="{'common-tab__tertiary-button-text--error': selectedLanguage.error}">
                        @if(publicLinkPoll.linkPollLanguagesSelected.length > 5){
                          {{selectedLanguage.appLanguage.substring(0, 2).toUpperCase()}}
                          }@else {
                          {{selectedLanguage.text}}
                        }
                      </p>
                      @if (!selectedLanguage.defaultOption) {
                        <button (click)="removeActiveLanguage(selectedLanguage)"
                          class="common-button__icon-xs-noborder">
                          <i class="lf-icon-close-thick common-icon__sm common-icon__neutral">
                          </i>
                        </button>
                      }
                    </button>
                  </li>
                }
                @if (publicLinkPoll.linkPollLanguagesApp.length !== publicLinkPoll.linkPollLanguagesSelected.length) {
                  <li #selectLanguagesContainer>
                    <button (click)="selectLanguagesDropdown.toggle($event, selectLanguagesContainer)"
                      class="common-tab__tertiary"
                      [ngClass]="{'common-tab__tertiary--active': openLanguagesDropdown}">
                      <p [afTranslate]="'protection-data-modal.add-translation'"
                        class="common-tab__tertiary-button-text">
                        _Añadir traducción
                      </p>
                      <i class="lf-icon-translate common-icon__md"></i>
                    </button>
                    <p-overlayPanel
                      #selectLanguagesDropdown
                      (onShow)="openLanguagesDropdown = true"
                      (onHide)="openLanguagesDropdown = false"
                      styleClass="common-dropdown-overlay__container">
                      <ng-template pTemplate="content">
                        <div class="common-dropdown__items-container">
                          @for (language of publicLinkPoll.linkPollLanguagesApp; track language.listValueId) {
                            @if (notSelectLanguage(language)) {
                              <button
                                (click)="selectLanguage(language.listValueId, selectLanguagesDropdown)"
                                class="common-dropdown-list__si-button">
                                <span-tooltip
                                  class="common-dropdown-list__si-text-container"
                                  [text]="language.text"
                                  [tooltipPosition]="'top'">
                                </span-tooltip>
                              </button>
                            }
                          }
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                  </li>
                }
              </ul>
            </div>
            <field-type-rich-text-editable class="w-[100%]"
              [field]="publicLinkPoll.linkPollDataTreatment"
              [preSelectItem]="publicLinkPoll.linkPollDataTreatmentText"
              (itemSelected)="publicLinkPoll.linkPollDataTreatmentText = $event.newValue">
            </field-type-rich-text-editable>
          </div>
          <div class="configure-customization__fields-container">
            <field-type-text-simple [field]="publicLinkPoll.youtubeLink"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.youtube"
              (itemSelected)="itemSelectedOn($event, 'youtube')">
            </field-type-text-simple>
            <field-type-text-simple [field]="publicLinkPoll.twitterLink"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.twitter"
              (itemSelected)="itemSelectedOn($event, 'twitter')">
            </field-type-text-simple>
          </div>
          <div class="configure-customization__fields-container">
            <field-type-text-simple [field]="publicLinkPoll.facebookLink"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.facebook"
              (itemSelected)="itemSelectedOn($event, 'facebook')">
            </field-type-text-simple>
            <field-type-text-simple [field]="publicLinkPoll.linkedinLink"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.linkedin"
              (itemSelected)="itemSelectedOn($event, 'linkedin')">
            </field-type-text-simple>
          </div>
          <div class="configure-customization__fields-container">
            <field-type-text-simple [field]="publicLinkPoll.instagramLink"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.instagram"
              (itemSelected)="itemSelectedOn($event, 'instagram')">
            </field-type-text-simple>
            <field-type-text-simple [field]="publicLinkPoll.phoneReference"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.phone"
              (itemSelected)="itemSelectedOn($event, 'phone')">
            </field-type-text-simple>
          </div>
          <div class="configure-customization__fields-container">
            <field-type-switch [field]="{label: 'corporative-information-modal.show-logo'|afTranslate}"
              [small]="true"
              [preSelectItem]="publicLinkPoll.company.corporativeInformation.showLogoInFooter"
              (itemSelected)="itemSelected('showLogoInFooter', $event.newValue)">
            </field-type-switch>
          </div>
        </div>
      }
    }
    <div class="common-modal__footer">
      <button [ngClass]="publicLinkPoll.stepState === 1?'common-button__text-border':'common-button__text-noborder'"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      @if (publicLinkPoll.stepState === 2) {
        <button class="common-button__text-border"
          (click)="publicLinkPoll.stepState = 1">
          <span class="common-button__text-title"
            [afTranslate]="'common.previous'">_Anterior</span>
        </button>
        <button class="common-button__text"
          (click)="publishPoll()">
          <span class="common-button__text-title"
            [afTranslate]="publicLinkPoll.published?'common.save':'common.publish'">_Publicar</span>
        </button>
      }@else {
        <button class="common-button__text"
          (click)="nextStep()">
          <span class="common-button__text-title"
            [afTranslate]="'common.next'">_Siguiente</span>
        </button>
      }
    </div>
  </div>
</div>
